import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { color, height, space, width } from 'styled-system';

const UnstyledRectShape = styled.div<any>`
  ${width};
  ${height};
  ${space};
  ${color};
`;

const RectShape = (props: ComponentProps<typeof UnstyledRectShape>) => (
  <UnstyledRectShape
    className="rect-shape"
    width={1}
    bg="sys.neutral.background.hover"
    {...props}
  />
);

export default RectShape;
